import { useMemo } from "react";

import { SEARCH_STRATEGIES } from "@/search/search.constants";
import useGetDeliverySearch from "@/search/useGetDeliverySearch";
import contentTypes from "@/view/constants/contentTypes";
import { type ContentType } from "@/view/constants/contentTypes/contentTypes.constants";
import {
  RELATED_CARDS_COUNT,
  extractResults,
  isStemContentPage,
  selectRelatedContent,
} from "./utils";

const contentTypesFilterForStudents = [
  contentTypes.GENERATION_GENIUS_VIDEO,
  contentTypes.ARTICLE,
  contentTypes.INTERACTIVE_VIDEO,
  contentTypes.PHET_SIMULATION,
  contentTypes.TUVA_DATASET,
];

const useFetchRelatedContentCards = ({
  contentId,
  isStudent = true,
  legacyFormat = false,
  contentType,
  contentSubject,
}: {
  contentId: string | number;
  isStudent?: boolean | undefined;
  legacyFormat?: boolean | undefined;
  contentType?: ContentType | undefined;
  contentSubject?: string | null | undefined;
}) => {
  const isStem = contentType
    ? isStemContentPage(contentType, contentSubject)
    : false;

  const queryParams: Record<string, any> = {
    strategy: SEARCH_STRATEGIES.SIMILAR_TO,
    similar_to: contentId,
    ...(!isStudent ? {} : { content_types: contentTypesFilterForStudents }),
  };

  const { data, refetch: fetchRelatedContentCards } = useGetDeliverySearch({
    queryParams,
  });

  const allResults = useMemo(() => extractResults({ data }), [data]);
  const selectedResults = useMemo(
    () => selectRelatedContent(allResults, isStem),
    [allResults, isStem],
  );
  const filteredCards = useMemo(
    () =>
      legacyFormat
        ? extractResults({
            data: { results: selectedResults },
            limit: RELATED_CARDS_COUNT,
            legacyFormat,
          })
        : selectedResults.slice(0, RELATED_CARDS_COUNT),
    [selectedResults, legacyFormat],
  );

  return { fetchRelatedContentCards, filteredCards };
};

export default useFetchRelatedContentCards;
